import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ArableAdviceService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);


  protected baseUrl = this.env.APIM_BASE_URL + '/arable-advice-service/';

  deleteCropField(
    cropFieldId: number,
  ) {
    return this.http.delete(`${this.baseUrl}crop-fields/${cropFieldId}`);
  }
}
